import { ServerPermission } from '../enums/server-permission.enum';

export const ACCOUNT_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.account.v2+json';

export class Account {
  public firstName: string;
  public lastName: string;
  public email: string;
  public realmId: string;
  public permissions: ServerPermission[];

  constructor(backEndAccount?: BackEndAccount) {
    if (backEndAccount) {
      this.firstName = backEndAccount.first_name;
      this.lastName = backEndAccount.last_name;
      this.email = backEndAccount.email;
      this.realmId = backEndAccount.realm_id;
      this.permissions = backEndAccount.permissions;
    }
  }

  /**
   * Convert this account to a server-side object.
   */
  public toBackEnd(): BackEndAccount {
    return {
      first_name: this.firstName,
      last_name: this.lastName,
      email: this.email,
      realm_id: this.realmId,
      permissions: this.permissions,
    };
  }
}

export interface BackEndAccount {
  first_name: string;
  last_name: string;
  email: string;
  realm_id: string;
  permissions: ServerPermission[];
}
